/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-02T18:37:11.295
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getInvoiceToolsHouseEditInit,
	getInvoiceToolsHouseView
} from '@api/smallapplication/InvoiceToolsHouse';

import {
listInvoiceToolsInvoiceInit,
listInvoiceToolsInvoiceByAuthorizations,
deleteInvoiceToolsInvoice
} from '@api/smallapplication/InvoiceToolsInvoice';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getInvoiceToolsHouseEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getInvoiceToolsHouseEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getInvoiceToolsHouseView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getInvoiceToolsHouseView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
